import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as svc from './tipos-servicio-service';
import { tiposServicioKeys } from './keys';
import type {
  CreateTipoServicioDto,
  UpdateTipoServicioDto,
  QueryTiposServicioDto,
} from './tipos-servicio-service';

export function useTiposServicioList(params: QueryTiposServicioDto) {
  return useQuery({
    queryKey: tiposServicioKeys.list(params as unknown as Record<string, unknown>),
    queryFn: () => svc.getTiposServicio(params),
    staleTime: 30_000,
  });
}

export function useTipoServicio(id: number) {
  return useQuery({
    queryKey: tiposServicioKeys.detail(id),
    queryFn: () => svc.getTipoServicio(id),
    enabled: id > 0,
    staleTime: 30_000,
  });
}

export function useCreateTipoServicio() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: CreateTipoServicioDto) => svc.createTipoServicio(dto),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: tiposServicioKeys.lists() });
    },
  });
}

export function useUpdateTipoServicio() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, dto }: { id: number; dto: UpdateTipoServicioDto }) =>
      svc.updateTipoServicio(id, dto),
    onSuccess: (_data, variables) => {
      qc.invalidateQueries({ queryKey: tiposServicioKeys.detail(variables.id) });
      qc.invalidateQueries({ queryKey: tiposServicioKeys.lists() });
    },
  });
}

export function useDeleteTipoServicio() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => svc.deleteTipoServicio(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: tiposServicioKeys.lists() });
    },
  });
}
